export default "__VITE_ASSET__Dv2Adf46__"